import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IfNotStandaloneDirective } from '@df/module-pwa/utils/if-not-standalone.directive';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { MentionMeWrapperComponent } from 'projects/app-default/src/app/module/mention-me/mention-me-wrapper.component';
export interface PageComponentMentionMeData extends NICmsContentComponent.IData {
    mmid: string;
    place: string;
    situation: string;
}
@ICmsComponent<PageComponentMentionMeComponent>({
    id: 'mention-me',
    name: 'Mention Me',
    tags: ['mention me', 'widget'],
    hidePreview: true,
    fields: [
        <NICmsContentField.IField>{
            key: 'mmid',
            type: NICmsContentField.EFieldType.text,
            title: 'MMID',
            required: true
        },
        <NICmsContentField.IField>{
            key: 'place',
            type: NICmsContentField.EFieldType.text,
            title: 'Place',
            required: true
        },
        <NICmsContentField.IField>{
            key: 'situation',
            type: NICmsContentField.EFieldType.text,
            title: 'Situation',
            required: true
        }
    ]
})
@Component({
    selector: 'page-component-mention-me',
    template: `<mention-me-wrapper
        *ifNotStandalone
        [mmid]="component.mmid"
        [place]="$any(component.place)"
        [situation]="$any(component.situation)"
    ></mention-me-wrapper>`,
    standalone: true,
    imports: [MentionMeWrapperComponent, IfNotStandaloneDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponentMentionMeComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: PageComponentMentionMeData;
}
